import { render, staticRenderFns } from "./RouterTags.vue?vue&type=template&id=11991224&scoped=true"
import script from "./RouterTags.vue?vue&type=script&lang=js"
export * from "./RouterTags.vue?vue&type=script&lang=js"
import style0 from "./RouterTags.vue?vue&type=style&index=0&id=11991224&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11991224",
  null
  
)

export default component.exports